import { Routes } from '@angular/router';
import { WelcomeComponent } from './pages/home/welcome/welcome.component';
import { ShipmentComponent } from './pages/shipment/shipment.component';
import { ShipmentDetailComponent } from './pages/shipment-detail/shipment-detail.component';
import { DeliveryEvidenceComponent } from './pages/delivery-evidence/delivery-evidence.component';
import { authGuard } from './guard/auth.guard';
import { homeGuard } from './guard/home.guard';
import { shipmentGuard } from './guard/shipment.guard';

export const routes: Routes = [
    { path: 'driver', component: WelcomeComponent, canActivate: [authGuard, homeGuard] },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: WelcomeComponent, canActivate: [authGuard, homeGuard] },
    { path: 'shipment', component: ShipmentComponent, canActivate: [authGuard, shipmentGuard] },
    { path: 'detail', component: ShipmentDetailComponent, canActivate: [authGuard, shipmentGuard] },
    { path: 'evidence', component: DeliveryEvidenceComponent, canActivate: [authGuard, shipmentGuard] }
];
